import { onboardingService } from "../../shell/services/onboarding";
import { middlewareService, postDownloadApi } from "../../shared/service";
import crypto from 'crypto';
import { utils } from "../../core/helpers/utils";

const OB_USER_TXN = "obUserTxn";
const pkey = utils.getPKey();

const ORO_GET = (url, headers, params) => {
  let query = "";

  headers = {
    "Content-Type": "application/json; charset=UTF-8",
    ...headers,
  };
  // console.log("params", "\nurl:", url, "\nparams:", params);
  if (params && Object.entries(params).length) {
    query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
  }

  const requestOptions = {
    method: "GET",
    headers: headers,
    credentials: "include",
  };

  if (query) url += "?" + query;

  return fetch(
    process.env.REACT_APP_API_URL + url,
    requestOptions
  ).then((response) => response.json());
};

const ORO_POST = (url, headers, params) => {
  headers = {
    "Content-Type": "application/json; charset=UTF-8",
    ...headers,
  };

  const requestOptions = {
    method: "POST",
    headers: headers,
    credentials: "include",
    body: JSON.stringify(params),
  };

  return fetch(
    process.env.REACT_APP_API_URL + url,
    requestOptions
  ).then((response) => response.json());
};

const getRank = () => {
  let headers = {
    "X-product": `orobonds:${"incredSubscription"}`
  }
  let payload = {
    product: "incredSubscription",
  };
  return ORO_POST("/waitlist/getRank", headers, payload);
};

const getUnitPrice = (PRODUCT_CODE, headers, units) => {
  return ORO_GET("/orobonds/getPrice", {...headers}, { product: PRODUCT_CODE, units });
};

const getAccessTokenHyperverge = () => {
  return ORO_GET("/hyperverge/getToken", {}, {});
};

const getHypervergeSync = (polling) => {
  const params = {
    isPolling: polling
  };

  return ORO_GET(`/hyperverge/user`, {}, params)
}


const getUserKycStatus = () =>{
  return ORO_GET("/hyperverge/syncKycResult", {}, {})
}


const getDataToTpd = (transactionId) =>{
  return ORO_GET(`/hyperverge/syncDataToTpd/${transactionId}`, {}, {})
}

const getTransactionIdHyperverge = () =>{
  return ORO_GET('/hyperverge/initialData')
}

const getInterstAmount = (PRODUCT_CODE, headers) => {
  var todaysDate = new Date();
  let day = todaysDate.getDate();
  let month = todaysDate.getMonth() + 1;
  let year = todaysDate.getFullYear();

  let currentDate = `${month}/${day}/${year}`;
  return ORO_GET
  (
    "/orobonds/getCoupons",
    {...headers},
    { product: PRODUCT_CODE,
    date: currentDate, 
    today: currentDate}
  );
};

const checkKycStatus = (email, pan, header) => {
  let payload = {
    payload: utils.encryptedPayload({
      email: email,
      pan: pan,
      checkpoints: [
        "noThirdPartyDataAdded",
        "partialThirdPartyDataAdded",
        "anyDocUploadedForThirdParty",
        "allDocUploadedForThirdParty",
        "noDocUploadedForThirdParty",
        "productWiseAccountStatus"
      ],
      path: "thirdPartyOnboarding",
      product: "orobonds",
      skipCache: true
    })
  };

  return ORO_POST("/stats/checkpoints/status", {}, utils.getPKey() ? payload : payload.payload);
};

const getAllAssets = (header, params) => {
  return ORO_GET("/orobonds/bonds/", header, params);
};

const getAssetDetails = (isin, headers) => {
  return ORO_GET("/orobonds/bonds/" + isin, {...headers}, {});
};

const submitIntent = async (isin, headers, params) => {
  try {
    return ORO_POST(`/orobonds/users/intent/${isin}`, headers, params)
  } catch (error) {
    throw new Error(`Failed to submit intent: ${error.message}`);
  }
};

const getRedeemptionAmount = (isin, headers) => {
  return ORO_GET("/orobonds/redeem/" + isin  + "/redemptionAmount", {...headers}, {});
};

const getQuoteRequest = (isin, headers, units, otp) => {
  let payload
  if (otp.length > 0) {
    payload = {
      payload: utils.encryptedPayload({
        "units": units,
        "validate": true,
        "otp": otp
      })
    }
  } else {
    payload = {
      "units": units,
      "sendOTP": true
    }
  }

  return ORO_POST("/orobonds/redeem/" + isin + "/raiseQuoteRequest", { ...headers }, payload);
};

const getAcceptRedeemQuote = (isin,headers, orderId, otp) => {
   let payload 
  if(otp.length > 0){
   payload = {
    "orderId": orderId,
    "validate": true,
    "otp": otp
   }
  }else{
     payload = { "orderId" : orderId,
      "sendOTP" : true
       }
  }
  
  return ORO_POST("/orobonds/redeem/" + isin  + "/acceptRedeemQuote", {...headers}, payload);
};

const getRejectRedeemQuote = (isin, headers, orderId) => {
  let payload =
  {
   "orderId": orderId
  }

 return ORO_POST("/orobonds/redeem/" + isin  + "/rejectRedeemQuote", {...headers}, payload);
};

const referralBanner = () => {
  return ORO_GET(`/ref/getBanners/?type=${'popup'}`, {}, {});
}


const getInvestmentAmount = (amount = 0, units = 0, PRODUCT_CODE, headers) => {
  let payload = utils.getPKey() ? {
    payload: utils.encryptedPayload({
      amount,
      units,
      product: PRODUCT_CODE,
    })
  } : {
    amount,
    units,
    product: PRODUCT_CODE,
  };
  return ORO_POST("/orobonds/getInvestmentAmount", { ...headers }, { ...payload });
};

const getKycStatusKra = (payload, headers) =>{
  return ORO_POST("/cvl/users/isKYCValid", { ...headers }, payload)
}

const getIpoAmountInvest = (headers, payload) => {
  return ORO_POST("/orobonds/pg/ipo/bid", {...headers}, payload);
};

const cancleBidIpo = (headers, payload) => {
  return ORO_POST("/orobonds/pg/ipo/cancelApplication", {...headers}, payload)
}

const updateStatus = (headers, payload) => {
    return ORO_POST("/orobonds/pg/ipo/status", {...headers}, payload)
}

const getIpoBidsConfirmed = (headers, payload) => {
  return ORO_POST("/orobonds/pg/ipo/confirmBids", {...headers}, payload);
};


const getRedeemOrderDetails = (isin, headers, orderId) =>{
  return ORO_GET("/orobonds/redeem/" + isin  + "/quotes/" + orderId, {...headers}, {});
}

const getThirdPartyData = (headers) => {
  return ORO_GET("/users/thirdpartyData", {...headers});
};

const updateThirdPartyData = (params, headers) => {
  return ORO_POST("/users/thirdpartyData", { ...headers }, { ...params });
};

const getUploadedDocsList = (pan, headers) => {
  return ORO_POST("/users/getUserDocsWithPan", { ...headers }, utils.getPKey() ? pan : pan.payload);
};

const getUserProfile = (pan) => {
  return ORO_GET("/orobonds/users/profile", {}, { pan });
};

const createPurchaseOrder = (params, PRODUCT_CODE, headers, isin) => {
  let url = "/orobonds/pg/purchase";

  if (params.exchange === 'nse') {
    url = "/orobonds/pg/v2/purchase";
  }

  const encryptParams = utils.encryptedPayload({ ...params, product: PRODUCT_CODE, ISIN: isin });

  return ORO_POST(
    url,
    { ...headers },
    utils.getPKey() ? { payload: encryptParams } : encryptParams
  );
};

const cashfreeCheckPaymentStatus = (url, headers, params) => {
  return ORO_POST(
    url,
    { ...headers },
    { ...params }
  );
}

const sendToExchange = (url, headers, params) => {
  return ORO_POST(
    url,
    { ...headers },
    { ...params }
  );
}

const getPaymentLink = (payload, headers) => {
  return ORO_POST('/bseRFQ/getPaymentLink', {...headers}, payload);
}

const getOrderDetails = (orderId, headers) => {
  return ORO_GET("/orobonds/pg/getOrderDetails", {...headers}, { orderId });
};

const getUnlistedOrderDetails = (product, orderId, headers)=> {
  return ORO_GET(`/unlisted/equities/${product}/transactions`, {...headers}, {orderId})
};

const signOroBond = (params, headers) => {
  return ORO_POST("/orobonds/digio/getEsigningUrlForBonds", {...headers}, params);
};

const getBondTransaction = () => {
  return ORO_GET("/orobonds/users/txns", {}, {});
};

const getUserReferalDetail = () => {
  return ORO_GET("/ref/getCode/", {}, {});
}

const getUserPans = (headers) => {
  return ORO_GET("/orobonds/users/getPans", {...headers});
};

const getPortfolio = (PRODUCT_CODE, headers) => {
  return ORO_GET(
    "/orobonds/users/portfolio", {...headers}, {product: PRODUCT_CODE}
  );
};

const getUserNameFromPan = (pan, headers) => {
  return ORO_POST("/digioEsign/getUserNameFromPan", {...headers}, { pan: pan, product: "oroBonds" });
};

const processUserAfterPan = (headers) => {
  return ORO_GET("/orobonds/users/processUser", {...headers}, {});
};

const obPreKycInvestNow = (params, headers) => {
  return ORO_POST("/raiseEvent",{...headers}, params);
}

const uploadDoc = (email, pan, docFile, docType, headers) => {
  const formData = new FormData();

  formData.append("name", docType);
  docFile.name
    ? formData.append("useruploadcandocs", docFile, docFile.name)
    : formData.append("useruploadcandocs", docFile);

  const requestOptions = {
    method: "POST",
    body: formData,
    credentials: "include",
    headers: {
      "use-pkey" : false,
      ...headers
    }
  };

  return fetch(
    process.env.REACT_APP_REPORTS_API_URL +
      "/users/uploadDocs?email=" +
      encodeURIComponent(email) +
      "&pan=" +
      pan +
      "&type=" +
      docType,
    requestOptions
  )
    .then((response) => response.json())
    .catch((err) => err);
};

const downloadPreviewData = (filename) => {
  return postDownloadApi("/users/v2/downloadDocs", { filename: filename }, true);
};

const getTimeline = (headers, params) => {
  return ORO_GET("/orobonds/pg/timeline", {...headers}, {...params});
};

const purchaseNeft = (payload, headers) => {
  return ORO_POST("/orobonds/pg/update", {...headers}, {
    ...payload,
    updatedOrder: {
      paymentType: "NEFT",
    },
  });
};

const purchaseNeftPaymentLink = (payload, headers) => {
  return ORO_POST("/orobonds/pg/update", {...headers}, payload);
};

const getRefCode = (product) => {
  const payload = {
    product: product,
  };
  // const requestOptions = {
  //   method: "POST",
  //   credentials: "include",
  //   headers: {
  //     "Content-Type": "application/json; charset=UTF-8"
  //   },
  //   body: JSON.stringify(payload),
  // };
  return ORO_GET('/ref/getCode', {"X-product": `orobonds:${product}`}, {});
}

const getObUserState = ({ email, pan }, PRODUCT_CODE, headers) => {
  const payload = {
    payload: utils.encryptedPayload({
      email,
      pan,
      checkpoints: [
        "obUserAdminResponseDone",
        "obUserApproved",
        "obUserNotInvested",
        "obOrderAttempted",
        "obDocSigned",
        "obPaymentDone",
        "obOrderApproved",
        "obOrderRejected",
      ],
      path: OB_USER_TXN,
      product: PRODUCT_CODE,
      productType: "bonds",
      skipCache: true
    })
  };
  return ORO_POST("/stats/checkpoints/status", { ...headers }, utils.getPKey() ? payload : payload.payload);
}

const dpValidation = (dpId, headers) => {
  const payload = utils.getPKey() ? { "payload": utils.encryptedPayload({ dpId }) } : { dpId };
  return ORO_POST('/dpList/validate', {...headers}, payload);
}

const addBankAccountApi = (payload, headers) => {
  return ORO_POST('/bank/accounts', {...headers}, payload);
}

const setConsentApi = (payload, headers) => {
  const _payload = utils.getPKey() ? { "payload": utils.encryptedPayload(payload) } : payload;
  return ORO_POST('/users/setConsent', {...headers}, _payload);
}

const getUserEmailApi = (headers) => {
  return ORO_GET('/users/getUserEmail', headers);
}

const getReferralListApi = (headers) => {
  return ORO_GET('/users/myReferrals', headers, {});
}

const getReferralTagApi = (payload,headers) => {
  return ORO_POST ('/ref/tag/', {...headers}, payload);
}


const getConsolidatedPortfolio = () => {
  const params = {
    consolidated: true,
  }
  const header = {
    "X-product": "orobonds:navi0",
  }
  return ORO_GET('/orobonds/users/portfolio', header, params);
}

const getTaxReport = (type,date) => {
  let url;
  if (date){
    url = "/orobonds/users/reports/" + type + "?date=" + date;
  }else{
    url = "/orobonds/users/reports/" + type ;
  }

  let _options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
      "Accept": "*/*",
      "X-product": "orobonds:" + "default"
    },
    credentials: 'include',
  };
  return fetch(process.env.REACT_APP_API_URL + url, _options)
    .then(res => res.blob())
    .then((result) => {
      if (result) {
        return result;
      }
    });
}
const getAllBonds = () => {
  return ORO_GET("/orobonds/bonds/", {}, {});
};

const getUserReferal = () => {
  return ORO_GET("/ref/myReferrals/", {}, {});
};

const getReferredUserActivity = () => {
  return ORO_GET("/ref/activity/", {}, {});
};

const getDigilockerDetails = (header) => {
  return ORO_POST("/orobonds/digio/onboarding/createKycRequest", header, {});
}

const getKycResponse = () => {
  return ORO_GET("/orobonds/digio/onboarding/getKycResponse", {}, {});
}

const npsDetails = () => {
  return ORO_GET("/nps/npsDetails", {}, {});
};

const setNpsFeedback = (payload, headers) => {
  return ORO_POST('/nps/feedBack', {...headers}, payload);
};

const getRedeemRequests = (isin) => {
  const header = {
    "X-product": `orobonds:default`,
  };
  return ORO_GET("/orobonds/redeem", header, {});
};

const submitDoucments = (headers) => {
  return ORO_POST('/orobonds/users/processUserDocuments', {...headers}, {});
};

const getFaq = (product, productType) => {
  if(product === 'others'){
    productType = "generic"; 
  }
  return ORO_GET('/faqs/' + productType + '?productType=' + product, { "use-pkey": false }, {})
};

const getEncryptedPKey = async () => {
  const url = `${process.env.REACT_APP_API_URL}/getPublicKey`;
  try {
    const response = await fetch(url, { method: 'GET' });

    if (!response.ok || response.errCode == 1) {
      throw new Error('Network response was not ok ' + response.statusText);
    }
    const pubKey = await response.text();
    const buffer = Buffer.from(utils.deriveSecretKey());
    const encrypted = crypto.publicEncrypt(pubKey, buffer);
    // console.log("PKey in Local : ", encrypted.toString('base64'));
    sessionStorage.setItem('pkey', encrypted.toString('base64'));
    return encrypted.toString('base64');
  } catch (err) {
    console.error("Error fetching public key: ", err);
    throw err;
  }
}

export {
  getRank,
  uploadDoc,
  signOroBond,
  getUserPans,
  getPortfolio,
  getUnitPrice,
  getTimeline,
  purchaseNeft,
  getAllAssets,
  getUserProfile,
  checkKycStatus,
  getAssetDetails,
  submitIntent,
  getOrderDetails,
  getThirdPartyData,
  getBondTransaction,
  getUserNameFromPan,
  getUploadedDocsList,
  getInvestmentAmount,
  createPurchaseOrder,
  cashfreeCheckPaymentStatus,
  sendToExchange,
  downloadPreviewData,
  updateThirdPartyData,
  getRefCode,
  getObUserState,
  dpValidation,
  getPaymentLink,
  getInterstAmount,
  addBankAccountApi,
  setConsentApi,
  getUserEmailApi,
  getReferralListApi,
  getConsolidatedPortfolio,
  getAllBonds,
  getDigilockerDetails,
  getKycResponse,
  npsDetails,
  setNpsFeedback,
  getUserReferal,
  getReferredUserActivity,
  getUserReferalDetail,
  getReferralTagApi,
  getRedeemRequests,
  getRedeemptionAmount,
  getQuoteRequest,
  getAcceptRedeemQuote,
  getRedeemOrderDetails,
  getRejectRedeemQuote,
  getIpoAmountInvest,
  processUserAfterPan,
  obPreKycInvestNow,
  submitDoucments,
  getIpoBidsConfirmed,
  cancleBidIpo,
  updateStatus,
  referralBanner,
  getTaxReport,
  getAccessTokenHyperverge,
  getTransactionIdHyperverge,
  getUnlistedOrderDetails,
  getDataToTpd,
  getFaq,
  getUserKycStatus,
  getHypervergeSync,
  purchaseNeftPaymentLink,
  getKycStatusKra,
  getEncryptedPKey
};
